import {
  NOTIFICATION_ADD,
  NOTIFICATION_REMOVE,
  NOTIFICATION_MARK_READ,
  NOTIFICATION_MARK_ALL_READ,
  NOTIFICATION_CLEAR_ALL,
  NOTIFICATION_SET_MUTE,
  NOTIFICATION_SET,
  NOTIFICATION_RESET,
  LOGOUT,
  RESET_STATE,
  STORE_LOGIN,
} from "../constants/action-types";
import { NotificationState } from "../types/notification.type";

const initialState: NotificationState = {
  notifications: [],
  muteNotifications: false,
  unreadCount: 0,
  lastNotificationId: undefined,
};

/**
 * Notifications reducer
 * @param {NotificationState} state
 * @param {any} action
 */
export default (state = initialState, action: any) => {
  switch (action.type) {
    case NOTIFICATION_ADD: {
      const newNotification = {
        ...action.notification,
        id: action.notification.id || `notification_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        isRead: false,
        timestamp: action.notification.timestamp || new Date().toISOString(),
      };

      const updatedNotifications = [newNotification, ...state.notifications];
      const unreadCount = updatedNotifications.filter(n => !n.isRead).length;

      return {
        ...state,
        notifications: updatedNotifications,
        unreadCount,
        lastNotificationId: newNotification.id,
      };
    }

    case NOTIFICATION_REMOVE: {
      const filteredNotifications = state.notifications.filter(
        notification => notification.id !== action.id
      );
      const unreadCount = filteredNotifications.filter(n => !n.isRead).length;

      return {
        ...state,
        notifications: filteredNotifications,
        unreadCount,
      };
    }

    case NOTIFICATION_MARK_READ: {
      const updatedNotifications = state.notifications.map(notification =>
        notification.id === action.id
          ? { ...notification, isRead: true }
          : notification
      );
      const unreadCount = updatedNotifications.filter(n => !n.isRead).length;

      return {
        ...state,
        notifications: updatedNotifications,
        unreadCount,
      };
    }

    case NOTIFICATION_MARK_ALL_READ: {
      const updatedNotifications = state.notifications.map(notification => ({
        ...notification,
        isRead: true,
      }));

      return {
        ...state,
        notifications: updatedNotifications,
        unreadCount: 0,
      };
    }

    case NOTIFICATION_CLEAR_ALL: {
      return {
        ...state,
        notifications: [],
        unreadCount: 0,
        lastNotificationId: undefined,
      };
    }

    case NOTIFICATION_SET_MUTE: {
      return {
        ...state,
        muteNotifications: action.muteNotifications,
      };
    }

    case NOTIFICATION_SET: {
      const notifications = action.notifications || [];
      const unreadCount = notifications.filter((n: any) => !n.isRead).length;

      return {
        ...state,
        notifications,
        unreadCount,
        lastNotificationId: notifications.length > 0 ? notifications[0].id : undefined,
      };
    }

    case NOTIFICATION_RESET:
      return {
        ...initialState,
      };
    
    case LOGOUT:
      // Don't reset notifications on logout - they should persist
      return state;

    case RESET_STATE:
      // Don't reset notifications on state reset - they should persist
      return state;

    case STORE_LOGIN:
      // Load notifications from localStorage on page refresh
      return {
        ...state,
        ...action.payload?.notifications,
      };

    default:
      return state;
  }
};
